import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgResource = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <defs>
      <path id="resource_svg__a" d="M0 0h24v24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="m20.083 16.257.179.066 2.894 1.373c.325.154.532.46.536.8a.89.89 0 0 1-.383.728l-.137.082-10.115 5.02a1.069 1.069 0 0 1-.794.059l-.134-.052-9.93-4.709a.905.905 0 0 1-.536-.8.89.89 0 0 1 .384-.727l.136-.083 3.05-1.513c.474-.235 1.07-.079 1.336.355a.84.84 0 0 1 .087.704.911.911 0 0 1-.332.453l-.148.09-1.4.696L12.5 22.53l8.077-4.008-1.227-.582a.929.929 0 0 1-.49-.534.84.84 0 0 1 .072-.706.972.972 0 0 1 .584-.44c.186-.052.382-.053.567-.004Zm.02-6.483.166.071 2.895 1.565a1.027 1.027 0 0 1 .153 1.69l-.137.094-10.115 5.723a.98.98 0 0 1-.81.068l-.134-.06-9.93-5.368a1.017 1.017 0 0 1-.528-.887c-.002-.308.131-.6.375-.803l.137-.094 3.05-1.725a.982.982 0 0 1 1.349.4 1.028 1.028 0 0 1-.27 1.294l-.12.08-1.447.82 7.755 4.281 8.124-4.596-1.274-.689a1.026 1.026 0 0 1-.415-1.367.985.985 0 0 1 1.177-.497ZM13.048.472l.182.069 9.929 4.9c.324.159.53.475.534.824a.927.927 0 0 1-.38.75l-.137.085-10.116 5.221a1.038 1.038 0 0 1-.798.063l-.134-.054-9.93-4.9a.935.935 0 0 1-.533-.824.927.927 0 0 1 .38-.75l.137-.085L12.296.549c.231-.119.5-.146.75-.077ZM12.78 2.44 4.763 6.58l7.734 3.89 8.092-4.177-7.808-3.853Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgResource)
const Memo = memo(ForwardRef)
export default Memo
